/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { datasetsGetDatasets } from "../../funcs/datasetsGetDatasets.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetDatasetsRequest$inboundSchema,
};

export const tool$datasetsGetDatasets: ToolDefinition<typeof args> = {
  name: "datasets-get-datasets",
  description: `Get a list of all premium and standard datasets

Returns a list of all datasets. Datasets are collections of features grouped by interest, relevance, commodity, and/or asset class.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await datasetsGetDatasets(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
